export enum ESortOption {
  ASC = 1,
  DESC = -1,
}
